import React from "react";
import { useDispatch, useSelector } from "types/store";
import styles from "../style.module.css";
import DynamicWidthSelector from "components/ChatGPT/DynamicWidthSelector";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { selectOnChangeWrapper } from "utils/select";
const ToneSelector = ({ menuPlacement, className, isDisabled, isNewChat, isDynamic, isStyled, color, selectorStyle, style, ...retProps } = {}) => {
    const dispatch = useDispatch();
    const chatTone = useSelector((state) => chatGPTReducer.getChatTone(state));
    const chatTones = useSelector((state) => chatGPTReducer.getChatToneOptions(state));
    const retValue = chatTones.find((v) => v.value === chatTone) ?? chatTones[0];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "chat-tone-select", className: styles.toneSelector + " " + (className ? className : "") + " " + (isNewChat ? styles.isNewChat : ""), style: style, ...retProps },
            React.createElement(DynamicWidthSelector, { options: chatTones, value: retValue, onChange: selectOnChangeWrapper((val) => dispatch(chatGPTReducer.updateChatTone(val))), placeholder: "Select Tone", menuPlacement: menuPlacement ?? "top", isDisabled: isDisabled, isDynamic: isDynamic, isNewChat: isNewChat, isStyled: isStyled, color: color, style: selectorStyle, isSearchable: true }))));
};
export default ToneSelector;
